import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class BikeBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'bikePlatformName',
      accessorFn: value => value.bikeOptions?.platformName,
      header: 'BIKE.fields.platformName',
      renderer: value => (value ? value : <Trans i18nKey="benefitsModule:BIKE.otherProvider" />) as React.ReactNode,
    },
    {
      id: 'bikeEmployerGrant',
      accessorFn: value => value.bikeOptions?.employerGrant,
      header: 'BIKE.fields.employerGrant',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
  ];
}
